.horizontalBarChartTextDecoration {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.rightAlignedColumn {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
}